const getWindowInnerWidth = (fallback=1280) => {
  if (typeof window === 'undefined') {
    return fallback;
  }
  return window.innerWidth;
};

module.exports = getWindowInnerWidth;



// WEBPACK FOOTER //
// ./src/common/utils/window-inner-width.js